import { isoDateTimeStringRegex, mobileNumberRegex } from "#lib/consts";
import { z } from "zod";

export const CreateLearnerPayload = z.object({
  name: z.string(),
  salutation: z.enum(["mr", "mrs", "miss"]),
  email: z.string().email(),
  mobileNumber: z
    .string()
    .regex(mobileNumberRegex, "Phone number should be a 10 digit number"),
  gender: z.enum(["male", "female", "other"]),
  dateOfBirth: z
    .string()
    .refine(
      (e) =>
        isoDateTimeStringRegex.test(e) &&
        new Date(e).getTime() <
          new Date().getTime() - 1000 * 60 * 60 * 24 * 365 * 14,
      "Minimum age to enrol is 14 years"
    ),
  category: z.enum(["general", "sc", "st", "obc"]),
  fatherName: z.string(),
  isPhysicallyChallenged: z.coerce.boolean(),
  highestQualification: z.enum([
    "q_10",
    "q_12",
    "q_graduate",
    "q_post_graduate",
  ]),
  addressLine1: z.string(),
  pincode: z.string(),
  highestQualificationCertificateFileId: z.coerce.bigint(),
  identityProofType: z.enum([
    "driving_license",
    "employers_card",
    "pan",
    "passport",
  ]),
  identityProofNumber: z.string(),
  identityProofFileId: z.coerce.bigint(),
  candidatePhotoFileId: z.coerce.bigint(),
  candidateSignatureFileId: z.coerce.bigint(),
  batchId: z.coerce.number(),
  courseId: z.coerce.number(),
  partnerId: z.string().optional(),
  examCenterState: z.string().optional(),
  examCenterCity: z.string().optional(),
  examLanguage: z.string().optional(),
  // courseIds: z.array(z.coerce.number()).optional(),
});

export const RePaymentPayload = z.object({
  name: z.string(),
  email: z.string().email(),
  mobileNumber: z
    .string()
    .regex(mobileNumberRegex, "Phone number should be a 10 digit number"),
  courseId: z.coerce.number(),
});

export const CreateLearnerDTO = z.object({
  name: z.string(),
  email: z.string().email(),
  mobileNumber: z
    .string()
    .regex(mobileNumberRegex, "Phone number should be a 10 digit number"),
  gender: z.enum(["male", "female", "other"]),
});

export const PaymentRequestDto = z.object({
  transactionId: z.string(),
  vleId: z.bigint().nullable(),
  userPayload: CreateLearnerPayload,
  transactionStatus: z.enum(["PENDING", "SUCCESS", "FAILED"]),
});

export const RePaymentRequestDto = z.object({
  transactionId: z.string(),
  vleId: z.bigint().nullable(),
  userPayload: RePaymentPayload,
  transactionStatus: z.enum(["PENDING", "SUCCESS", "FAILED"]),
});

export const paymentResponsePayload = z.object({
  csc_txn: z.string(),
  merchant_id: z.string(),
  csc_id: z.string(),
  merchant_txn: z.string(),
  txn_status: z.string(),
  merchant_txn_date_time: z.string(),
  product_id: z.string(),
  txn_amount: z.string(),
  amount_parameter: z.string(),
  txn_mode: z.string(),
  txn_type: z.string(),
  merchant_receipt_no: z.string(),
  csc_share_amount: z.string(),
  pay_to_email: z.string(),
  currency: z.string(),
  discount: z.string(),
  param_1: z.string(),
  param_2: z.string(),
  param_3: z.string(),
  param_4: z.string(),
  txn_status_message: z.string(),
  status_message: z.string(),
});

export const assistingVle = z.object({
  id: z.bigint(),
  email: z.string(),
  cscId: z.string(),
});

export const productDetailsSchema = z.object({
  productId: z.string(),
  amount: z.string(),
  selfAmount: z.string().optional(),
  courseName: z.string(),
  receiptCourseName: z.string().optional(),
  cscShareAmount: z.string(),
  contactEmail: z.string(),
  ccAvenueMerchantId: z.string().optional(),
  ccAvenueAccessCode: z.string().optional(),
  ccAvenueWorkingKey: z.string().optional(),
  adminApiBaseUrl: z.string().optional(),
});

export const productDetailsSchemaRePayment = z.object({
  amount: z.string(),
});
